import React from 'react';
import DoNotSell from './DoNotSell';

type DoNotSellProps = {
  setClosePopup: Function;
};

const DoNotSellContainer = (props: DoNotSellProps): JSX.Element => {
  return (
    <div className="reveal-overlay" style={{ display: 'block' }}>
      <div
        data-reveal
        className="reveal privacy-policy-ccpa-popup regulatory-updates-modal"
        style={{ display: 'block' }}>
        <DoNotSell setClosePopup={props.setClosePopup} />
      </div>
    </div>
  );
};

export default DoNotSellContainer;
